import { Icon, type RadioChangeEvent, RadioPills } from 'ui';
import type { ChannelEntityType } from '../../types';

export type ChannelEntityOption = 'community' | 'event' | 'giving' | 'program' | 'video';

type P = {
  onChange?: (value: RadioChangeEvent) => void;
  options: ChannelEntityOption[];
  value?: ChannelEntityType;
};

const EntityTypeRadioPills = ({ onChange, options, value }: P) => {
  const generatePills = () => {
    const pills = [];

    if (options.length > 1) {
      pills.push({
        icon: <Icon icon="dot-grid-line" />,
        label: 'All',
        value: undefined,
      });
    }

    // TODO: It is weird that values in these objects must start uppercase, otherwise filters do not work
    if (options.includes('community')) {
      pills.push({
        icon: <Icon icon="classify-2-line" />,
        label: 'Communities',
        value: 'Community',
      });
    }

    if (options.includes('program')) {
      pills.push({
        icon: <Icon icon="mortarboard-line" />,
        label: 'Programs',
        value: 'Program',
      });
    }

    if (options.includes('event')) {
      pills.push({
        icon: <Icon icon="event" />,
        label: 'Events',
        value: 'Event',
      });
    }

    if (options.includes('giving')) {
      pills.push({
        icon: <Icon icon="hand-heart-line" />,
        label: 'Giving',
        value: 'Giving',
      });
    }

    if (options.includes('video')) {
      pills.push({
        icon: <Icon icon="video-line" />,
        label: 'Videos',
        value: 'Video',
      });
    }

    return pills;
  };

  return <RadioPills items={generatePills()} onChange={onChange} value={value} />;
};

export default EntityTypeRadioPills;
